<mat-toolbar class="toolbar top element-shadow" *transloco="let t">
  <img alt="broken" src="assets/vectors/logo.svg">

  <div class="bar-btn-container">
    <button class="avatar-button" type="button" (click)="openProfile()" [attr.aria-label]="t('profile')">
      <app-user-avatar [avatarConfig]="user()?.avatarConfig" [username]="user()?.username" [size]="40" />
    </button>
  </div>
</mat-toolbar>

<div class="home-container">
  <div class="home-sidebar">
    <app-sidebar-nav></app-sidebar-nav>
  </div>
  <div class="quest-list">
    <router-outlet></router-outlet>
  </div>
</div>
